import React from "react";
import { inject, observer } from "mobx-react";
import BaseMLBTrackingAccuracyReportContainer from "./BaseMLBTrackingAccuracyReportContainer";
import NonMLBTrackingAccuracyReportTable from "../components/accuracyReports/NonMLBTrackingAccuracyReportTable";
import IncidentTypes from "../constants/IncidentTypes";
import WinterGameActionDropDownContainer from "./WinterGameActionDropDownContainer";

class WinterTrackingAccuracyReportContainer extends React.Component {
  render() {
    const rootStore = this.props.rootStore;
    const description =
      "A real-time pitch-by-pitch data report that monitors the overall quality of data and video systems used for Winter games.<br /> <br /> <b>Note: Orange cells denote games with Club system tracking integrated</b>";

    //May need to create a WinterTrackingAccruacyRportTable
    const reportTable = (
      <NonMLBTrackingAccuracyReportTable
        data={rootStore.WinterGameActionStore.trackingAccuracyReportSource.data}
        gameStatuses={rootStore.veracityStore.gameStatuses}
        canCreateIncident={rootStore.authStore.hasIncidentEdit}
        groupsToShow={rootStore.tableControlsStore.state}
        dropDownContainer={WinterGameActionDropDownContainer}
      />
    );
    return (
      <BaseMLBTrackingAccuracyReportContainer
        header="Winter Statcast Data & Coaching Video Report"
        description={description}
        reportSource={
          rootStore.WinterGameActionStore.trackingAccuracyReportSource
        }
        reportTable={reportTable}
        incidentTypesToFetch={[IncidentTypes.WIN, IncidentTypes.SYSTEM]}
        showSystemIncidentButton={rootStore.authStore.hasIncidentEdit}
      />
    );
  }
}

export default inject("rootStore")(
  observer(WinterTrackingAccuracyReportContainer),
);
